<section class="how-it-works" aria-labelledby="how-it-works-title">
  <div class="how-it-works--container">
    <div class="how-it-works--header">
      <span class="how-it-works--accent" aria-hidden="true"></span>
      <h2 id="how-it-works-title" class="how-it-works--title">How it works?</h2>
      <span class="how-it-works--line" aria-hidden="true"></span>
    </div>
    <img
      src="/about-us/howItWorks.png"
      alt="How it works - Departments and institutions publish datasets, data is discovered through a unified catalogue, access is governed by policy and consent, innovators and governments build applications and analytics"
      class="how-it-works--image"
      loading="lazy"
    />
  </div>
</section>
